var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "tags-nav" }, [
    _c(
      "div",
      { staticClass: "close-con" },
      [
        _c(
          "el-dropdown",
          {
            staticStyle: { "margin-top": "5px" },
            attrs: { transfer: "" },
            on: { command: _vm.handleTagsOption },
          },
          [
            _c("el-button", {
              attrs: { size: "small", type: "text", icon: "el-icon-close" },
            }),
            _c(
              "el-dropdown-menu",
              { attrs: { slot: "dropdown" }, slot: "dropdown" },
              [
                _c("el-dropdown-item", { attrs: { command: "refresh" } }, [
                  _vm._v("刷新"),
                ]),
                _c("el-dropdown-item", { attrs: { command: "close-all" } }, [
                  _vm._v("关闭所有"),
                ]),
                _c("el-dropdown-item", { attrs: { command: "close-others" } }, [
                  _vm._v("关闭其他"),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "ul",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.visible,
            expression: "visible",
          },
        ],
        staticClass: "contextmenu",
        style: {
          left: _vm.contextMenuLeft + "px",
          top: _vm.contextMenuTop + "px",
        },
      },
      _vm._l(_vm.menuList, function (item, key) {
        return _c(
          "li",
          {
            key: key,
            on: {
              click: function ($event) {
                return _vm.handleTagsOption(key)
              },
            },
          },
          [_vm._v(_vm._s(item))]
        )
      }),
      0
    ),
    _c(
      "div",
      { staticClass: "btn-con left-btn" },
      [
        _c("el-button", {
          attrs: { type: "text", icon: "el-icon-arrow-left" },
          on: {
            click: function ($event) {
              return _vm.handleScroll(240)
            },
          },
        }),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "btn-con right-btn" },
      [
        _c("el-button", {
          attrs: { type: "text", icon: "el-icon-arrow-right" },
          on: {
            click: function ($event) {
              return _vm.handleScroll(-240)
            },
          },
        }),
      ],
      1
    ),
    _c(
      "div",
      {
        ref: "scrollOuter",
        staticClass: "scroll-outer",
        on: { DOMMouseScroll: _vm.handlescroll, mousewheel: _vm.handlescroll },
      },
      [
        _c(
          "div",
          {
            ref: "scrollBody",
            staticClass: "scroll-body",
            style: { left: _vm.tagBodyLeft + "px" },
          },
          [
            _c(
              "transition-group",
              { attrs: { name: "taglist-moving-animation" } },
              _vm._l(_vm.list, function (item, index) {
                return _c(
                  "el-tag",
                  {
                    key: `tag-nav-${index}`,
                    ref: "tagsPageOpened",
                    refInFor: true,
                    attrs: {
                      size: "large",
                      name: item.name,
                      hit: false,
                      "data-route-item": item,
                      closable: item.name !== "home",
                      effect: _vm.isCurrentTag(item) ? "dark" : "light",
                    },
                    on: {
                      close: function ($event) {
                        return _vm.handleClose(item)
                      },
                    },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.handleClick(item)
                      },
                      contextmenu: function ($event) {
                        $event.preventDefault()
                        return _vm.contextMenu(item, $event)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.showTitleInside(item)))]
                )
              }),
              1
            ),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }